import type { TypeNode } from '../types/model';

type TypeTreeNodeProps = {
  node: TypeNode;
  depth: number;
  selectedId: string | null;
  onSelect: (id: string) => void;
};

export const TypeTreeNode = ({ node, depth, selectedId, onSelect }: TypeTreeNodeProps) => {
  const isSelected = selectedId === node.type.id;
  return (
    <>
      <button
        className={`tree-item ${isSelected ? 'active' : ''}`}
        style={{ paddingLeft: `${12 + depth * 18}px` }}
        type="button"
        onClick={() => onSelect(node.type.id)}
      >
        <span>{node.type.name || 'Unnamed type'}</span>
        <span className="meta-pill">{node.type.fields.length} fields</span>
        {node.type.isIndexed && <span className="badge">Indexed</span>}
      </button>
      {node.children.map((child) => (
        <TypeTreeNode key={child.type.id} node={child} depth={depth + 1} selectedId={selectedId} onSelect={onSelect} />
      ))}
    </>
  );
};
